import annotator from 'annotator';

import xpathRange from 'xpath-range';
let TextSelector = annotator.ui.textselector.TextSelector


// Note: This is a copy of `annotator.ui.textselector.TextSelectorcaptureDocumentSelection`
// with only a 2-4 lines of code added.
// Modify TextSelector to prevent range normalization happening twice
// when mouseup event is fired again by dragging mouse from outside the element.
// Since mouseup event came from outside the element, the selection is not changed
// thus causing it to go through this function twice which causes incorrectly
// highlighted range of text.
TextSelector.prototype.captureDocumentSelection = function () {
    let i,
        len,
        ranges = [],
        rangesToIgnore = [],
        selection = global.getSelection();

    if (selection.isCollapsed) {
        return [];
    }

    for (i = 0; i < selection.rangeCount; i++) {
        let r = selection.getRangeAt(i),
            browserRange = new xpathRange.Range.BrowserRange(r),
            normedRange = browserRange.normalize().limit(this.element);

        // Return when ranges are already normalized
        if (r.isNormalized) {
            return ranges;
        }

        if (normedRange === null) {
            rangesToIgnore.push(r);
        } else {
            ranges.push(normedRange);
        }
    }

    selection.removeAllRanges();

    for (i = 0, len = rangesToIgnore.length; i < len; i++) {
        selection.addRange(rangesToIgnore[i]);
    }

    for (i = 0, len = ranges.length; i < len; i++) {
        let range = ranges[i],
            drange = this.document.createRange();
        drange.setStartBefore(range.start);
        drange.setEndAfter(range.end);
        // Mark normalized ranges
        drange.isNormalized = true;
        selection.addRange(drange);
    }


    return ranges;
};

export default TextSelector;
